'use client';
import { css } from 'styled-system/css';

export const menuIconStyle = {
	menuIcon: css({
		_mars: {
			position: 'relative',
			flex: 'none',
		},
	}),
	menuLiveIcon: css({
		_mars: {
			display: 'flex',
			position: 'absolute',
			bottom: 0,
			right: 0,
			width: '12px',
			height: '12px',
			bgColor: 'var(--s800)',
			rounded: '6px',
			'& .icon': {
				width: '12px',
				height: '12px',
				color: 'status.negative',
			}
		},
	}),
	rightIcon: css({
		_mars: {
			ml: 'auto',
			color: 'black.3',
		}
	}),
	tip: css({
		_mars: {
			color: 'blackOpacity.87',
			bgColor: '#FFF5C2',
		},
	}),
};